import Collection from './collection.js';
import PayrollItem, {consts} from 'newModels/payroll-item.js';

export default class PayrollItems extends Collection {
    url() {
        if (this.company) {
            return (
                `/PayrollItems/getForCompany/${this.company.get('objectId')}`
            );
        }
        return '/PayrollItems';
    }

    initialize(models, {company = null, unsyncable = false}) {
        super.initialize(...arguments);
        this.model = PayrollItem;
        this.company = company;
        this.unsyncable = unsyncable;
        this.searchableAttributes = ['name'];
        if (!this.options.sortKey) {
            this.options.sortKey = 'name';
        }
        this.pagination = false;
        return this;
    }

    fetch() {
        return super.fetch(...arguments);
    }

    // The reason sync is overriden is so that we can transparently use
    // fetch() to get the payroll items for a given company. Dunno if it's the
    // right call tho.
    sync(method, collection, options) {
        if (this.unsyncable) {
            return this.map(model => model.attributes);
        }

        if (!this.company || method !== 'read') {
            return super.sync(...arguments);
        }

        options.url = this.finalUrl();
        options.headers = {'Authorization': app.user.getAccessToken().id};
        return super.sync(method, collection, options);
    }

    popular({limit = 12, threshold = 0} = {}) {
        const models = _(this.filter(model => {
            return ((model.get('popularity') || -1) >= threshold);
        })).sortBy(model => {
            return (model.get('popularity') || 0) * -1;
        });

        return _(models).first(limit);
    }

    getByCategory(category) {
        return this.filter(model => model.get('category') === category);
    }

    getSelected() {
        return this.filter(model => model.isSelected());
    }

    getSelectedByCategory(category) {
        return this.filter(model => {
            return (
                model.get('category') === category &&
                model.isSelected()
            );
        });
    }

    clearSelection() {
        this.getSelected().forEach(model => model.toggleSelect());
        return this;
    }

    clearSelectionForCategory(category) {
        this.getSelectedByCategory(category).forEach(model => {
            model.toggleSelect();
        });
        return this;
    }

    getSelectableAdditionals() {
        const types = [
            consts.TYPE_ADDITION,
            consts.TYPE_BONUS,
            consts.TYPE_DEDUCTION,
            consts.TYPE_CP38,
            consts.TYPE_ZAKAT,
            consts.TYPE_OVERTIME,
            consts.TYPE_BENEFIT,
            consts.TYPE_UNPAID_LEAVE
        ];

        return new PayrollItems(
            this.filter(model => {
                // TODO: Revise after backend is ported to PP2
                const includeItem = (item) =>
                    item.get('type') !== consts.TYPE_UNPAID_LEAVE || (
                        item.get('type') === consts.TYPE_UNPAID_LEAVE &&
                        item.get('category') !== 0
                    );

                return (
                    model.get('hiddenAt') === null && ((
                            types.includes(model.get('type')) &&
                            includeItem(model)
                        ) || (
                            model.get('type') === consts.TYPE_MTD &&
                            model.get('subtype') === 'custom'
                        )
                    )
                );
            }),
            {unsyncable: true}
        );
    }

    getSelectablePreviousPayslips() {
        const nonNetTypes = [
            consts.TYPE_ADDITION,
            consts.TYPE_BONUS,
            consts.TYPE_DEDUCTION,
            consts.TYPE_CP38,
            consts.TYPE_MTD,
            consts.TYPE_ZAKAT,
            consts.TYPE_BENEFIT,
            consts.TYPE_BASE,
            consts.TYPE_OVERTIME
        ];
        const netTypes = [
            consts.TYPE_HRDF,
            consts.TYPE_EIS,
            consts.TYPE_SOCSO,
            consts.TYPE_EPF,
            consts.TYPE_UNPAID_LEAVE
        ];

        return new PayrollItems(
            this.filter(model => {
                return (
                    model.get('hiddenAt') === null && (
                        nonNetTypes.indexOf(model.get('type')) >= 0 || (
                            netTypes.indexOf(model.get('type')) >= 0 &&
                            model.get('isUnit') === false &&
                            model.get('isNet') === true
                        )
                    )
                );
            }),
            {unsyncable: true}
        );
    }

    getSelectableDefaults() {
        const types = [
            consts.TYPE_ADDITION,
            consts.TYPE_BONUS,
            consts.TYPE_DEDUCTION,
            consts.TYPE_ZAKAT,
            consts.TYPE_BENEFIT,
            consts.TYPE_CP38,
            consts.TYPE_OVERTIME
        ];

        return new PayrollItems(
            this.filter(model => {
                return (
                    model.get('hiddenAt') === null &&
                    model.get('allowRecurrency') === true &&
                    types.indexOf(model.get('type')) >= 0
                );
            }),
            {unsyncable: true}
        );
    }

    getMappable() {
        return new PayrollItems(
            this.filter(
                model => model.get('hiddenAt') === null &&
                    model.isIntegrationMappable()
            ),
            {unsyncable: true}
        );
    }

    getMappableDefaults() {
        const types = [
            consts.TYPE_SOCSO,
            consts.TYPE_BASE,
            consts.TYPE_MTD,
            consts.TYPE_EPF,
            consts.TYPE_EIS,
            consts.TYPE_HRDF,
            consts.TYPE_ZAKAT
        ];

        return new PayrollItems(
            this.filter(model => {
                return (
                    types.indexOf(model.get('type')) >= 0 &&
                    model.get('subtype') !== 'custom' &&
                    model.get('isUnit') === false
                );
            }),
            {unsyncable: true}
        );
    }
}



// WEBPACK FOOTER //
// ./app/new-collections/payroll-items.js